import { Title } from './Title';
export function SectionSubHeading(props) {
    return <Title appearance="subsection" as="h4" {...props}/>;
}
